<template>
    <div  v-if="!isLoading && event!==null">
        <div class="row">
                <div class="container">
                    <div class="tournament-top" :style="`background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.30), rgba(0, 0, 0, 0.55)),url('`+$urlOrDefault(event.tournament.cover_picture,'event-cover')+`');`">

                        <div class="tournament-info">
                            <div class="row">
                                <div class="col-sm-5 text-left">
                                    <h1 class="tournament-name">{{ event.tournament.name }}</h1>
                                </div>
                                <div class="col-sm-7 text-right top-information">
                                  <svg class="fill-color top-icon" width="17" height="19"><use xlink:href="#calendar"  /></svg>
                                  {{ new Date(event.tournament.start_date).getDay() }} {{ monthForm(new Date(event.tournament.start_date).getMonth()) }} a
                                    {{ new Date(event.tournament.end_date).getDay() }} {{ monthForm(new Date(event.tournament.end_date).getMonth()) }}
                                  <svg class="fill-color top-icon" width="16" height="18"><use xlink:href="#shield"  /></svg> {{ event.teams.length }} Equipas <svg class="fill-color top-icon" width="16" height="18"><use xlink:href="#thropy"  /></svg> {{ event.tournament.prize }}
                                </div>
                            </div>
                        </div>

                        <div class="tournament-line bg-color"></div>

                    </div>
                </div>
        </div>

        <LatestNews :news="news" v-if="news !== null && !event.meta.hasOwnProperty('arena_twitch_channel')"></LatestNews>

        <div class="row latest-news-row bg-color" v-if="event.meta.hasOwnProperty('arena_twitch_channel')">
          <div class="container">
            <TwitchLive width="80%" height="500px" :channel="event.meta.arena_twitch_channel.value"></TwitchLive>
          </div>
        </div>

        <div class="row info-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-9">
                        <h2 class="text-left">Equipas</h2>

                        <div class="teams-container row">

                            <div class="col-sm-12 col-md-3" v-for="team in event.teams">
                                <TeamList v-bind:team="team"></TeamList>
                            </div>

                        </div>

                    </div>
                    <div class="col-md-3">
                        <h2 class="text-left">Jogos</h2>
                        <MatchList v-bind:tournament_id="event.tournament.id"></MatchList>
                    </div>
                </div>

            </div>
        </div>

        <div class="row stages-section" v-for="stage in event.stages">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-sm-3">
                        <h2 class="text-left">{{ stage.title }}</h2>
                        <p class="text-left text-white" style="white-space: pre" v-if="stage.note!==null && stage.note!==''">{{ stage.note }}</p>
                    </div>

                    <div class="col-md-8 col-sm-9">
                        <ul class="select-bracket-tabs text-right" v-if="stage.brackets.length>0">
                            <li :class="(brackets[stage.id]===index ? 'border-color text-color active':'')" v-for="(bracket,index) in stage.brackets" :data-bracket-id="index" v-on:click="changeBracket(stage.id,index)">{{ bracket.title }}</li>
                        </ul>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">

                        <div class="bracket-row" v-if="stage.brackets.length>0">
                            <div class="col-md-12 bracket-display">

                                <div class="bracket-wrapper">
                                    <Bracket :bracket="stage.brackets[brackets[stage.id]]" :id="brackets[stage.id]"></Bracket>
                                </div>
                            </div>
                        </div>

                        <template v-if="stage.groups.length > 0">
                          <div class="groups-row"  v-if="stage.groups.length <= 1">
                            <div class="col-md-12" v-for="group in stage.groups">
                              <Group :group="group" :id="group.id" :event="event.tournament.id"></Group>
                            </div>
                          </div>
                          <div class="groups-row"  v-if="stage.groups.length > 1">
                            <div class="col-md-6" v-for="group in stage.groups">
                              <Group :group="group" :id="group.id" :event="event.tournament.id"></Group>
                            </div>
                          </div>
                        </template>


                    </div>

                </div>
            </div>
        </div>

        <div class="row classifications-section">

            <div class="container">

                <h2 class="text-left">Classificação final</h2>

                <div class="row classifications-list">

                        <template v-for="(classif,index) in classificationsFormated">

                            <Classification :i="index" :classif="classif"></Classification>

                        </template>

                </div>

            </div>

        </div>
    </div>

</template>

<script>
    import EventRepository from "../api/EventRepository";
    import MatchList from "../components/Match/MatchList";
    import Bracket from "../components/Event/Bracket";
    import Classification from "../components/Event/Classification";
    import RtpArenaApi from "../api/RtpArenaApi";
    import Funcs from '../functions';
    import TeamList from "../components/Event/TeamList";
    import Group from "../components/Event/Group";
    import TwitchLive from "@/components/Event/TwitchLive";
    import LatestNews from "@/components/Event/LatestNews";

    export default {
        name: "Event",
        components: {LatestNews, TwitchLive, Group, TeamList, Classification, Bracket, MatchList},
        data: function(){
            return {
                isLoading: true,
                event:null,
                brackets:null,
                news:null,
                tournament_prize:null,
            }
        },
        computed: {
            classificationsFormated: function(){

                let teams_formatted=this.event.teams.reduce(function(obj,item){
                   obj[item.id] = item;
                   return obj;
                },{});

                let form={};

                let order=[];

                const classifc=this.event.classifications;

                for(let k in classifc){

                    const classif=classifc[k];

                    if(form.hasOwnProperty(classif.classification.id)){
                        form[classif.classification.id].teams.push(teams_formatted[classif.team_id]);
                    } else {

                        form[classif.classification.id]={
                            'order':classif.order,
                            'teams':[teams_formatted[classif.team_id]],
                            'classification':classif.classification,
                            'prize':classif.prize,
                            'note':classif.note
                        };
                        order[classif.order]=classif.classification.id;
                    }

                }

                let final=[];

                for(let k in order){

                    if(order.hasOwnProperty(k) && order[k]!=='' && form.hasOwnProperty(order[k])){
                        final.push(form[order[k]]);
                    }

                }


                return final;
            },
        },
        created: function(){
            this.getData();
           window.addEventListener("load", this.findSVGElements, false);
        },
        methods: {
              async getData(){
                  EventRepository.getEvent(this.$route.params.id).then(response => {
                    let data=response.data;
                    this.event=data;
                    this.isLoading = false;

                    let bracketStages={};

                    for(let k in this.event.stages){
                      bracketStages[this.event.stages[k].id]=0;
                    }

                    this.brackets=bracketStages;

                    if(this.event.meta.hasOwnProperty('arena_tournament_url')){
                      RtpArenaApi.getNews({'post_type':'any','quantity':4,'event':this.event.meta.arena_tournament_url.value}).then(
                          response => {
                            this.news=response.data;
                          }
                      );
                    }

                    setTimeout(e => {

                      if(this.event.meta.hasOwnProperty('arena_tournament_color') && this.event.meta.arena_tournament_color.value !== ''){

                        let color=this.event.meta.arena_tournament_color.value;
                        if(!color.includes("#")){
                          color="#"+color;
                        }

                        let sheet = document.createElement('style')
                        sheet.innerHTML = ".bg-color { background-color:"+color+"!important; } .text-color { color:"+color+"!important; } .border-color { border-color:"+color+"!important; } .fill-color { fill:"+color+"!important; }";
                        document.body.appendChild(sheet);
                      } else {
                        let color="#3174F6";
                        let sheet = document.createElement('style')
                        sheet.innerHTML = ".bg-color { background-color:"+color+"!important; } .text-color { color:"+color+"!important; } .border-color { border-color:"+color+"!important; .fill-color { fill:"+color+"!important; } }";
                        document.body.appendChild(sheet);
                      }

                    },100);

                  });
              },

              changeBracket(stageId,bracketId){
                  vm.$set(this.brackets, stageId, bracketId)
              },


              monthForm: function(month){
                  const MONTHS={
                      0:'Jan',
                      1:'Feb',
                      2:'Mar',
                      3:'Abr',
                      4:'Mai',
                      5:'Jun',
                      6:'Jul',
                      7:'Aug',
                      8:'Sep',
                      9:'Oct',
                      10:'Nov',
                      11:'Dec'
                  };

                  return MONTHS[month];
              },
              getImageUrl: function(url){
                return Funcs.getImageUrl(url);
              },

              getSubDocument: function(embedding_element){
                if (embedding_element.contentDocument)
                {
                  return embedding_element.contentDocument;
                }
                else
                {
                  let subdoc = null;
                  try {
                    subdoc = embedding_element.getSVGDocument();
                  } catch(e) {}
                  return subdoc;
                }
              },

              findSVGElements: function(){
                var elms = document.querySelectorAll(".top-icon");
                for (var i = 0; i < elms.length; i++)
                {
                  var subdoc = this.getSubDocument(elms[i])
                  if (subdoc)
                    subdoc.getElementById("svgbar").setAttribute("fill", "lime");
                }
              }
          }
    }
</script>

<style>
    /* Color variables
    .bg-color {
        background-color:#3174F6;
    }

    .text-color {
        color:#3174F6;
    }

    .border-color {
        border-color: #3174F6;
    }*/
</style>
<style scoped>

    /* Global components */


    /* Tournament top */
    .tournament-top {
        height: 333px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        box-shadow: 0px 4px 40px rgba(0, 0, 0,0.5);
    }

    .tournament-info {
        height: 35px;
        position: absolute;
        bottom: 20px;
        width:100%;
        padding-left: 30px;
        padding-right: 30px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        color:#FFF;
    }

    .tournament-info > .row > div > .tournament-name {
        line-height: 35px;
        font-size: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-top:0;
        margin-bottom: 0;
    }

    .tournament-info > .row > .text-right {
        line-height: 35px;
        font-size: 15px;
    }

    .tournament-info .icon {
        width: 18px;
        height: 18px;
        display: inline-block;
        margin-left: 10px;
        margin-right: 5px;
        vertical-align: middle;
    }

    .tournament-top .tournament-line {
        width: 90%;
        position: absolute;
        bottom:0px;
        height: 3px;
        left: 5%;
    }

    .info-section {
        margin-top: 20px;
    }

    .stages-section {
        margin-top: 50px;
        padding-top: 10px;
    }

    .stages-section p {
        font-size: 12px;
        font-weight: 500;
    }

    .stages-section .bracket-display {
        position: relative;
        padding-left: 0px;
        padding-bottom: 20px;
    }

    .bracket-wrapper {
        overflow-x: auto;
        overflow-y: auto;
        margin-top: 20px;
    }

    .select-bracket-tabs {
        margin-top: 5.5px;
        margin-right:-15px;
    }

    .select-bracket-tabs > li {
        display: inline;
        padding: 10px 20px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        text-transform: uppercase;
        border-top: 2px solid #28333A;
        background-color: #141F26;
    }

    .select-bracket-tabs > li.active {
        background-color: #0A151C;
    }

    .classifications-list {
        margin-top: 20px;
    }

    .classifications-section {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .classifications-list > .col-md-3 {
        margin-top: 60px;
    }

    .stages-section:nth-child(even){
      background-color: #0A151C;
    }

    .latest-news-row {
      padding-top: 100px;
      margin-top: -70px;
      padding-bottom: 20px;
    }

    .top-icon {
      width: 16px;
      height: 18px;
      margin-left: 15px;
      margin-right: 2.5px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom:2.5px;
    }

    .top-information {
      vertical-align: middle;
    }
</style>
<style>
  #app {
    background: #141F26;
    min-height: 100vh;
  }
</style>